<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <div class="mainBody">
            <div class="searchBox">
                <div class="searchGroup">
                    <label>邮箱：</label>
                    <el-input v-model="search_Obj.f_mail" clearable @keyup.enter.native="doSearch"></el-input>
                </div>
                <div class="searchGroup">
                    <label>是否中奖：</label>
                    <el-select v-model="search_Obj.f_is_winning" clearable placeholder="请选择" @keyup.enter.native="doSearch">
                        <el-option v-for="item in enuObj('winning_state')" :key="'winning_state'+item.key" :label="item.title" :value="item.key"> </el-option>
                    </el-select>
                </div>
                <el-button type="primary" plain @click.native="doSearch">搜索</el-button>
            </div>
            <div class="dataBox">
                <el-table :data="tableData" @selection-change="selectChanges" v-loading="loading" border stripe>
                    <el-table-column prop="nickname" label="昵称"></el-table-column>
                    <el-table-column prop="mail" label="邮箱" ></el-table-column>
                    <el-table-column prop="winning_rate" label="中奖概率"></el-table-column>
                    <el-table-column prop="is_winning" label="状态" sortable="custom">
                        <template slot-scope="scope">
                            <span>{{ transEnu(scope.row.is_winning, "winning_state") }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="remark" label="备注"></el-table-column>
                    <el-table-column label="操作" width="100" align="center">
                        <template slot-scope="scope">
                            <el-button size="mini" plain type="primary" @click="edit(scope.index, scope.row)">设置</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pageBox">
                <el-pagination background layout="total, prev, pager, next, jumper" :current-page="current" :page-size="pagesize" :total="total" @current-change="pageChange"></el-pagination>
            </div>
        </div>
        <UserEdit
            width="800px"
            :id="model_id"
            title="设置中奖情况"
            :isshow="editshow"
            @on-save-ok="saveOk"
            @on-close="closeEditDialog">
        </UserEdit>
    </el-dialog>
</template>

<script>
import listutil from "@/libs/listutil"
import UserEdit from "./useredit"

export default {
    name: 'raffleUserList',
    mixins: [listutil],
    components: {UserEdit},
    props: {
        isshow: {
            type: Boolean,
            default() {
                return false;
            }
        },
        raffle_id: {
            type: Number,
            default() {
                return -1;
            }
        },
        title: {
            type: String,
            default() {
                return ""
            }
        },
        width: {
            type: String,
            default() {
                return '800px';
            }
        }
    },
    watch: {
        isshow(newv, old) {
            this.showflag = newv;
            this.search_Obj.f_raffle_id = this.raffle_id;
            this.getData()
        },
    },
    data() {
        return {
            m_name: '抽奖用户',
            menu_id: 9999,
            pagesize: 10,
            list_url: "/api/admin/raffle/userList",
            search_Obj: {
                f_raffle_id: '',
                f_mail: '',
                f_is_winning: '',
            },
            del_Obj:{
                url:'/api/admin/deviceuser/del',
                data:{
                    ids:''
                }
            },
            enu_name: ['winning_state'],
            showflag: false,
        };
    },
    methods: {
        closeDialog() {
            this.$emit("on-close")
        },
        set(row){
            console.log(row.id)
        }
    }
};
</script>